import { FC } from 'react';

import classNames from 'classnames';
import { Button } from 'ui/components/common';
import { cn, convertToMegabytes } from 'utils/helpers';
import useModal from 'ui/partials/Modal/useModal';
import { SIZE } from 'utils/constants';

type PROPS = {
  fileSize?: string;
  maxSize?: number;
};

const AttachmentsTooLargeModal: FC<PROPS> = ({
  fileSize = 0,
  maxSize = 15,
}) => {
  const { hideModal } = useModal();

  return (
    <>
      <div className="space-y-[6px]">
        <div
          className={classNames(
            'font-semibold',
            'text-sm',
            'leading-6',
            'tracking-wider',
          )}
        >
          The attachment exceeds the allowable limit.
        </div>
        <div>
          {`The accumulated file size you are trying to upload is
        ${fileSize}. This exceeds the maximum allowed limit of ${convertToMegabytes(
          maxSize,
        ).replace(
          /\.\d+/,
          '',
        )}. Please choose smaller files or reduce the number of files."`}
        </div>
      </div>
      <div
        className={cn(
          'pt-[22px] mt-[22px]',
          'flex justify-end gap-2',
          'border-t-[0.5px] border-separator-primary',
        )}
      >
        <Button
          size={SIZE.Small}
          onClick={hideModal}
          label="OK"
          className="primary sm"
        />
      </div>
    </>
  );
};

export default AttachmentsTooLargeModal;
